import React, { useState } from 'react';
import { useAuth } from 'utils/AuthProvider';
import ClientMenu from './clientMenu';
import AdminMenu from './AdminMenu';
import AccountantMenu from './accountantMenu';
import HRMenu from './HRMenu';
import SupportMenu from './SupportMenu';
import FinanceMenu from './FinanceMenu';
import TaxBackOfficeMenu from './TaxBackOfficeMenu'; // NEW Component for Tax Back Office
import AccountantBackOfficeMenu from './AccountantBackOfficeMenu'; // NEW Component for Accountant Back Office
import './SideBarNav.css';

export default function SideBarNav() {
  const { isClient, isAdmin, isAccountant, user } = useAuth();

  const [isTaxExpanded, setIsTaxExpanded] = useState(false);
  const [isFinCenExpanded, setIsFinCenExpanded] = useState(false);

  const handleToggle =
    (setter: React.Dispatch<React.SetStateAction<boolean>>) =>
    (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      e.preventDefault();
      setter((prev) => !prev);
    };

  const menuProps = {
    isTaxExpanded,
    setIsTaxExpanded,
    isFinCenExpanded,
    setIsFinCenExpanded,
    handleToggle,
  };

  const departments = user?.accountant_profile?.departments ?? [];
  const hasHRDepartment = departments.some((d) => d.id === 8); // HR Back Office
  const hasSupportDepartment = departments.some((d) => d.id === 6); // Support Back Office
  const hasFinanceDepartment = departments.some((d) => d.id === 5); // Finance Back Office
  const hasTaxBackOffice = departments.some((d) => d.id === 4); // NEW - Tax Back Office
  const hasAccountantBackOffice = departments.some((d) => d.id === 2); // NEW - Accountant Back Office

  return (
    <div className="custom-sidebar">
      <div className="custom-menu-items">
        <h2 className="custom-menu-heading">Main Menu</h2>
        <div className="separator"></div>

        {isClient ? (
          <ClientMenu {...menuProps} />
        ) : (isAdmin || isAccountant) && hasHRDepartment ? (
          <HRMenu />
        ) : (isAdmin || isAccountant) && hasSupportDepartment ? (
          <SupportMenu />
        ) : (isAdmin || isAccountant) && hasFinanceDepartment ? (
          <FinanceMenu {...menuProps} />
        ) : (isAdmin || isAccountant) && hasTaxBackOffice ? (
          <TaxBackOfficeMenu {...menuProps} /> // NEW - Menu for Tax Back Office
        ) : (isAdmin || isAccountant) && hasAccountantBackOffice ? (
          <AccountantBackOfficeMenu {...menuProps} /> // NEW - Menu for Accountant Back Office
        ) : isAdmin ? (
          <AdminMenu {...menuProps} />
        ) : (
          <AccountantMenu {...menuProps} />
        )}
      </div>
    </div>
  );
}
